import { track } from '@bnnvara/analytics/src/track';
import { BaseButton } from '@bnnvara/buttons';
import { GridItem } from '@bnnvara/grids';
import { Chevron } from '@bnnvara/icons/src/components/UserInterfaceIcons/Chevron';
import { useRouter } from 'next/router';
import { PropTypes } from 'prop-types';
import React from 'react';

import Link from '../../components/Link';
import TYPES from './enum/cardListContentTypes';

const ComposableShowMoreButton = ({ label, type }) => {
  const { query } = useRouter();

  if (!label) {
    return null;
  }

  const route = type === TYPES.article ? '/artikelen' : '/videos';

  return (
    <GridItem
      columnStartSm="1"
      columnEndSm="span 12"
      columnStartMd="3"
      columnEndMd="11"
      centered
    >
      <Link href={route}>
        <BaseButton
          type="link"
          as="span"
          variant="underline"
          rel="alternate"
          onClick={() => {
            track(`${query.slug}`, 'click', `toon-meer-${type}`);
          }}
        >
          {label}
          <Chevron />
        </BaseButton>
      </Link>
    </GridItem>
  );
};

ComposableShowMoreButton.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(TYPES)).isRequired,
};

export default ComposableShowMoreButton;
